var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('vue-title', {
    attrs: {
      "title": "Thank You - MyWhoosh! Your Indoor Cycling Solution"
    }
  }), _c('section', {
    staticClass: "description"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('div', {
    staticClass: "p-5"
  }, [_c('svg', {
    staticClass: "checkGreen",
    attrs: {
      "viewBox": "0 0 120 121",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "60",
      "cy": "60.5",
      "r": "60",
      "fill": "#1DA46E"
    }
  }), _c('path', {
    attrs: {
      "d": "M89.1818 40.5L49.1818 80.5L31 62.3182",
      "stroke": "white",
      "stroke-width": "6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])]), _vm._m(0), _vm.getLinks ? _c('EventLinks', {
    attrs: {
      "links": _vm.getLinks,
      "new_version": true
    }
  }) : _vm._e()], 1)])])])], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('h1', {
    staticClass: "heading"
  }, [_vm._v("Thank You for Registering!")]), _c('p', {
    staticClass: "thank-you"
  }, [_vm._v(" We're currently processing your registration. Our team is working hard to make sure everything goes smoothly for you. If you have any questions or need help, feel free to email us at "), _c('a', {
    attrs: {
      "href": "mailto:racecontrol@mywhoosh.com"
    }
  }, [_vm._v("racecontrol@mywhoosh.com")]), _vm._v(". Please do not forget to read MyWhoosh Cycling Esports Rules & Regulations ")])]);
}]

export { render, staticRenderFns }